var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCrossUbd({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 10,
    viewBox: "0 0 9 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.43437 1.94688C8.67772 1.70353 8.67773 1.30898 8.43437 1.06562C8.19102 0.822275 7.79648 0.822275 7.55312 1.06563L4.5 4.11875L1.44688 1.06563C1.20353 0.822275 0.808975 0.822275 0.565625 1.06562C0.322275 1.30898 0.322275 1.70352 0.565625 1.94687L3.61875 5L0.565626 8.05312C0.322275 8.29647 0.322275 8.69102 0.565625 8.93437C0.808975 9.17773 1.20352 9.17773 1.44687 8.93437L4.5 5.88125L7.55312 8.93437C7.79647 9.17772 8.19102 9.17773 8.43437 8.93437C8.67773 8.69102 8.67773 8.29648 8.43437 8.05312L5.38125 5L8.43437 1.94688Z",
    fill: "#595959"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrossUbd);
export default __webpack_public_path__ + "static/media/CrossUBD.46660b19785f71395f4da24772d228f9.svg";
export { ForwardRef as ReactComponent };